/**
 * Usage API client — personal consumption stats for the calling user.
 */

import { apiClient } from './client';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface UsageByOperation {
  operation: string;
  prompt_tokens: number;
  completion_tokens: number;
  total_tokens: number;
  event_count: number;
}

export interface MyUsageStats {
  /** Token totals */
  prompt_tokens: number;
  completion_tokens: number;
  total_tokens: number;
  event_count: number;
  last_token_use_at: string | null;
  /** Per-operation breakdown (sorted by total_tokens desc) */
  by_operation: UsageByOperation[];
  /** Document conversion */
  docling_conversions: number;
  docling_pages: number;
  /** Content created */
  ontology_count: number;
  node_count: number;
  edge_count: number;
  kb_count: number;
  ko_count: number;
  ku_count: number;
}

// ─── API ──────────────────────────────────────────────────────────────────────

export const meUsageApi = {
  /** GET /api/auth/me/usage — personal consumption stats for the calling user. */
  getUsage(): Promise<MyUsageStats> {
    return apiClient.get<MyUsageStats>('/api/auth/me/usage');
  },
};

// Made with Bob
